import { render } from "./CommentCount.vue?vue&type=template&id=4213a614"
import script from "./CommentCount.vue?vue&type=script&lang=js"
export * from "./CommentCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__